import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import Lenis from '@studio-freight/lenis'
import AOS from "aos";
import "aos/dist/aos.css";

createApp(App).use(store).use(router).mount("#app");

AOS.init({
  duration: 1200,
  offset: 20,
});

// const lenis = new Lenis()

// function raf(time) {
//     lenis.raf(time)
//     requestAnimationFrame(raf)
// }

// requestAnimationFrame(raf)

/*=============== CHANGE BACKGROUND HEADER ===============*/
function scrollHeader() {
  const header = document.querySelector("#header");
  const scrollTop = document.querySelector("#scroll-top");
  const nav = document.querySelector("#nav-bottom");

  if (this.scrollY >= 50) {
    header.classList.add("scroll-header");
    scrollTop.classList.add("show-scroll");
  } else {
    header.classList.remove("scroll-header");
    scrollTop.classList.remove("show-scroll");
  }

  if (nav) {
    if (this.scrollY >= 350) nav.classList.add("show-nav");
    else nav.classList.remove("show-nav");
  }
}

function move(e) {
  this.querySelectorAll(".icon-3d").forEach((layer) => {
    const speed = layer.getAttribute("data-speed");

    const x = (window.innerWidth - e.pageX * speed) / 60;
    const y = (window.innerHeight - e.pageY * speed) / 60;

    layer.style.transform = `translateX(${x}px) translateY(${y}px)`;
  });
}

window.addEventListener("scroll", scrollHeader);
document.addEventListener("mousemove", move);
// lenis.on('scroll', () => {
//     // console.log(e)
// })
